<div class="page-header">
  <div class="header-text">
    <h1 class="header-title">{{ title() }}</h1>
    @if (subtitle()) {
      <p class="header-sub">{{ subtitle() }}</p>
    }
  </div>
  <div class="header-actions"><ng-content /></div>
</div>
